import PropTypes from "prop-types"
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core"
import { formatMoneyValue } from "../../../utils/financialHelper"

const ComparativoReceitaRecebidoTable = ({ relatorio, franquia = '' }) => (
  <>
    <Typography variant="h6" style={{ margin: '24px 0 0 8px', padding: '0 0 0 16px' }}>Receitas{franquia ? ` ${franquia}` : ''}</Typography>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold', width: '50%' }}>Tipo</TableCell>
            <TableCell style={{ fontWeight: 'bold', width: '50%' }}>Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {relatorio?.manualBillingsReceived != null && (
            <TableRow>
              <TableCell>Contas a Receber Manual</TableCell>
              <TableCell>{formatMoneyValue(relatorio.manualBillingsReceived)}</TableCell>
            </TableRow>
          )}
          {relatorio?.taxesFromOfx != null && (
            <TableRow>
              <TableCell>Taxas de Adesão OFX</TableCell>
              <TableCell>{formatMoneyValue(relatorio.taxesFromOfx)}</TableCell>
            </TableRow>
          )}
          {relatorio?.taxesFromM3tas != null && (
            <TableRow>
              <TableCell>Taxas de Adesão M3tas - Vida</TableCell>
              <TableCell>{formatMoneyValue(relatorio.taxesFromM3tas)}</TableCell>
            </TableRow>
          )}
          {relatorio?.zurichComissionsFromOfx != null && (
            <TableRow>
              <TableCell>Comissão Zurich OFX</TableCell>
              <TableCell>{formatMoneyValue(relatorio.zurichComissionsFromOfx)}</TableCell>
            </TableRow>
          )}
          {relatorio?.zurichComissionsFromM3tas != null && (
            <TableRow>
              <TableCell>Comissão Zurich M3tas - Vida</TableCell>
              <TableCell>{formatMoneyValue(relatorio.zurichComissionsFromM3tas)}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)

ComparativoReceitaRecebidoTable.propTypes = {
  relatorio: PropTypes.shape({
    manualBillingsReceived: PropTypes.number.isRequired,
    taxesFromOfx: PropTypes.number.isRequired,
    taxesFromM3tas: PropTypes.number.isRequired,
    zurichComissionsFromOfx: PropTypes.number,
    zurichComissionsFromM3tas: PropTypes.number,
  }).isRequired,
  franquia: PropTypes.string,
}

ComparativoReceitaRecebidoTable.defaultProps = {
  franquia: '',
}

export default ComparativoReceitaRecebidoTable
